// extracted by mini-css-extract-plugin
module.exports = {"personDefault":"common-ComposerList__personDefault--yvd-b","personMobile":"common-ComposerList__personMobile--3c9ks"};